const getters = {
  token: (state) => state.user.token,
  profile: (state) => state.user.profile,
  drinkStatus: (state) => state.user.drinkStatus,
  subscribeStatus: (state) => state.user.profile.subscriptions,
};
export default getters;
